(function () {
  'use strict';

  function getBackgroundColor(context, width, height) {
    var points = [
      [1, 1],
      [width - 2, 1],
      [1, height - 2],
      [width - 2, height - 2]
    ];
    var total = [0, 0, 0];

    points.forEach(function (point) {
      var pixel = context.getImageData(point[0], point[1], 1, 1).data;
      total[0] += pixel[0];
      total[1] += pixel[1];
      total[2] += pixel[2];
    });

    return total.map(function (value) { return value / points.length; });
  }

  function isForeground(data, index, background) {
    if (data[index + 3] < 20) return false;

    var red = data[index];
    var green = data[index + 1];
    var blue = data[index + 2];
    var distance = Math.sqrt(
      Math.pow(red - background[0], 2) +
      Math.pow(green - background[1], 2) +
      Math.pow(blue - background[2], 2)
    );

    return distance > 34 || Math.max(red, green, blue) - Math.min(red, green, blue) > 24;
  }

  function findBandCenter(imageData, width, height, yPercent, fallback) {
    var centerY = Math.round((yPercent / 100) * (height - 1));
    var radius = Math.max(4, Math.round(height * 0.035));
    var startY = Math.max(0, centerY - radius);
    var endY = Math.min(height - 1, centerY + radius);
    var rows = endY - startY + 1;
    var columns = new Array(width).fill(0);
    var background = imageData.background;
    var data = imageData.data;

    for (var y = startY; y <= endY; y += 1) {
      for (var x = 0; x < width; x += 1) {
        var index = (y * width + x) * 4;
        if (isForeground(data, index, background)) columns[x] += 1;
      }
    }

    var threshold = Math.max(2, Math.round(rows * 0.22));
    var runs = [];
    var runStart = -1;
    var runWeight = 0;

    for (var column = 0; column <= width; column += 1) {
      var active = column < width && columns[column] >= threshold;
      if (active && runStart < 0) {
        runStart = column;
        runWeight = columns[column];
      } else if (active) {
        runWeight += columns[column];
      } else if (runStart >= 0) {
        runs.push({ start: runStart, end: column - 1, weight: runWeight });
        runStart = -1;
        runWeight = 0;
      }
    }

    if (!runs.length) return fallback;

    runs.sort(function (a, b) {
      var aScore = a.weight * Math.max(1, a.end - a.start + 1);
      var bScore = b.weight * Math.max(1, b.end - b.start + 1);
      return bScore - aScore;
    });

    var best = runs[0];
    var center = ((best.start + best.end) / 2 / width) * 100;
    return Math.max(18, Math.min(82, center));
  }

  function findOverallCenter(imageData, width, height) {
    var minX = width;
    var maxX = -1;
    var data = imageData.data;
    var background = imageData.background;

    for (var y = 0; y < height; y += 1) {
      for (var x = 0; x < width; x += 1) {
        var index = (y * width + x) * 4;
        if (isForeground(data, index, background)) {
          minX = Math.min(minX, x);
          maxX = Math.max(maxX, x);
        }
      }
    }

    if (maxX < minX) return 50;
    return ((minX + maxX) / 2 / width) * 100;
  }

  function alignSection(section) {
    if (section.dataset.featureAligned === 'true') return;
    section.dataset.featureAligned = 'true';

    var images = Array.prototype.slice.call(section.querySelectorAll('.product-feature-details__crop img'));
    var source = images[0];
    if (!source) return;

    var analyzer = new Image();
    analyzer.crossOrigin = 'anonymous';
    analyzer.src = source.currentSrc || source.src;

    function reveal() {
      section.classList.add('product-feature-details--aligned');
    }

    function analyze() {
      try {
        var width = 180;
        var height = Math.max(180, Math.round(width * analyzer.naturalHeight / analyzer.naturalWidth));
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        var context = canvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(analyzer, 0, 0, width, height);

        var pixelData = context.getImageData(0, 0, width, height);
        var pixels = {
          data: pixelData.data,
          background: getBackgroundColor(context, width, height)
        };
        var overallCenter = findOverallCenter(pixels, width, height);

        images.forEach(function (image) {
          var yPercent = parseFloat(image.dataset.featureY || '50');
          var xPercent = findBandCenter(pixels, width, height, yPercent, overallCenter);
          image.style.transform = 'translate(-' + xPercent.toFixed(2) + '%, -' + yPercent + '%)';
        });
      } catch (error) {
        // Cross-origin or unusual source images keep their safe Liquid defaults.
      } finally {
        reveal();
      }
    }

    if (analyzer.complete && analyzer.naturalWidth) {
      analyze();
    } else {
      analyzer.addEventListener('load', analyze, { once: true });
      analyzer.addEventListener('error', reveal, { once: true });
    }
  }

  function init() {
    var sections = document.querySelectorAll('[data-feature-auto-align="true"]');

    if (!('IntersectionObserver' in window)) {
      sections.forEach(alignSection);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        alignSection(entry.target);
      });
    }, { rootMargin: '800px 0px' });

    sections.forEach(function (section) { observer.observe(section); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
